import { render, staticRenderFns } from "./materialRecipe.vue?vue&type=template&id=c8da1f98&scoped=true&"
import script from "./materialRecipe.vue?vue&type=script&lang=js&"
export * from "./materialRecipe.vue?vue&type=script&lang=js&"
import style0 from "./materialRecipe.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./materialRecipe.vue?vue&type=style&index=1&id=c8da1f98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8da1f98",
  null
  
)

export default component.exports